/**
 * Application Constants
 * This class contains all response codes and constants used throughout the application
 * 
 * @author Based on PHP AppConstants class
 */

const AppConstants = {
  appName: "MFG Invest Global",
  adminUserName: "admin_configuration",
  adminNickName: "MFG Invest Global",
  generalGroup: "general",
  code: 'CODE',
  messages: 'MESSAGES',

  // Response to client
  updateRequired: 106,
  updateAvailable: 110,
  responseOk: 200,
  responseNeedAdminApproval: 201,
  responseGroupRestriction: 210,
  responseWaiting: 202,
  responseCanceled: 203,
  responseNeedPermission: 204,
  responseAlreadyOk: 205,
  responseNotFound: 206,
  responseFailed: 207,
  responseError: 208,

  // Response on send SMS or EMAIL
  messagesDeviceNotFound: 601,
  messagesErrorOTP: 602,
  messagesErrorSendingSMS: 603,
  messagesOK: 604,

  // Response on check device
  deviceOk: 400,
  deviceNotFound: 401,
  accountNotFound: 402,
  errorType: 403,

  // Response on check account
  accountExist: 901,

  // Response on login
  loginOk: 500,
  loginWaitAccess: 501,
  loginBlocked: 502,
  loginIncorrect: 503,
  loginNotActive: 504,
  loginIpBlocked: 512,

  // Block user
  blockUser: 510,
  blockedByUser: 511,

  // Check secret key
  invalidSecretKey: 706,

  // Response catch error
  catchError: 707,

  // Invalid input data
  invalidInputs: 708,
  invalidInput: "error",

  // Maintenance
  maintenance: 800,

  // Device headers keys
  deviceId: "device-id",
  deviceIp: "device-ip",
  deviceLocation: "device-position",
  deviceModel: "device-model",
  deviceOs: "device-os",

  // Type of notification
  notificationForAll: 0,
  notificationForCustomers: 1,
  notificationForAgents: 2,
  notificationForAdmins: 3,
  notificationCustom: 4,
  notificationForUser: 5,
  notificationForDevice: 6,

  // Helper function to log errors
  handlerError: (error) => {
    // You can add additional logging here if needed
  }
};

export default AppConstants;

